import Load from './load.vue'
import Vue from 'vue'
import { createAPI } from 'cube-ui'

let closeLoading = false
let closeError = false

createAPI(Vue, Load, true)

const load = {
  loading () {
    if (closeLoading) return
    Load.$create({}).loading()
  },
  hide () {
    Load.$create({}).hide()
  },
  error (message) {
    if (closeError) return
    Load.$create({
      message
    }).error()
  },
  toggleLoading (close) {
    closeLoading = close
  },
  toggleError (close) {
    closeError = close
  },
  toggle (close) {
    load.toggleLoading(close)
    load.toggleError(close)
  }
}

export default load
